import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Grid, Card } from '@material-ui/core/';
import event_icon from "../../assets/images/event.svg";

import Sidebar from '../../components/SideBar';
import Label from '../../components/Label';
import Button from '../../components/Button';

import EventApi from '../../services/event';

import { Line, Body } from './styles';

const Events = (props) => {
    const [event, setEvent] = useState([]);

    useEffect(() => {
        return EventApi.listEvents()
        .then(resp => {
            if (!!resp.data) setEvent(resp.data.data);
        })
        .catch(function(error) {
            console.log(error)
        });
    }, []);

    const page = (
        <>
        <Line>
            <Label
                className='first'
                size='min'
                color='dark'
                align='left'
                weight='500'
            >
                Eventos Cadastrados
            </Label>
            <div>
                <Link to={`/new-events`}>
                    <Button
                        size='nano'
                        color='dark'
                        format='solid'
                        width='100%'
                    >
                        Novo Evento
                    </Button>
                </Link>
            </div>
        </Line>
            <Grid
                container
                spacing={2}
                direction="row"
                justify="flex-start"
                alignItems="flex-start"
            >
                {event.map((elem, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card>
                            <Body>
                                <img src={event_icon} alt="Event" />
                                <Label font='Roboto' weight='600' size='min' color='dark' align='left' padding='10px 0' >
                                    {elem.name}
                                </Label>
                                <Line>
                                    <Label
                                        className='first'
                                        size='pico'
                                        color='dark'
                                        align='left'
                                        padding='0'
                                    >
                                        {elem.start_at ? new Date(elem.start_at).toLocaleString() : ''}
                                    </Label>
                                    <Label
                                        size='pico'
                                        color='success' //{ new Date(elem.start_at) >= new Date() ? 'success':'error' }
                                        align='left'
                                        weight='700'
                                        padding='0'
                                    >
                                        {/* { new Date(elem.start_at) >= new Date() ? 'AGENDADO':'FINALIZADO' } */}
                                        AGENDADO
                                    </Label>
                                </Line>
                                <Label size='nano' color='dark' align='left' padding='10px 0' >
                                    {elem.description.substring(0,100)}...
                                </Label>
                                <Link to={`/events/${elem.id}`}>
                                    <Button
                                        size='nano'
                                        color='dark'
                                        format='solid'
                                        width='100%'
                                    >
                                        DETALHES
                                    </Button>
                                </Link>
                            </Body>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    )
    return ( <Sidebar current='Eventos' content={page}/> )
}

export default Events;
